import { IFullPlanDetail } from "../../../interfaces/api";
import SingleInfoBenefit from "./SingleInfoBenefit.component";
import { getDoubleDeepHMO } from "../../../functions/planDetails";

const DataTableDetailDental = ({ data }: { data: IFullPlanDetail }) => {
  const preventiveDentalBenefits = getDoubleDeepHMO(
    data,
    "Dental Services",
    "Preventive Dental (Routine)"
  );
  const comprehensiveBenefits = getDoubleDeepHMO(
    data,
    "Dental Services",
    "Comprehensive Dental"
  );

  return (
    <div
      className="grid-x"
      style={{
        backgroundColor: "white",
        border: "1px solid #D3E1F0",

        textAlign: "left",
      }}
    >
      {/* <div
        className="grid-x"
        style={{
          backgroundColor: "#F5F9FD",

          width: "100%",
          padding: "32px 20px",
          borderBottom: "1px solid #D3E1F0",
        }}
      >
        <div
          className="cell small-12"
          style={{
            fontSize: "25px",
            fontWeight: 600,
          }}
        >
          Preventive
        </div>
      </div> */}
      <SingleInfoBenefit
        benefit={preventiveDentalBenefits}
        title="Preventive (Routine)"
      />
      {/* <div
        className="grid-x"
        style={{
          backgroundColor: "#F5F9FD",

          width: "100%",
          padding: "32px 20px",
          borderBottom: "1px solid #D3E1F0",
        }}
      >
        <div
          className="cell small-12"
          style={{
            fontSize: "25px",
            fontWeight: 600,
          }}
        >
          Comprehensive
        </div>
      </div> */}
      <SingleInfoBenefit
        benefit={comprehensiveBenefits}
        title="Comprehensive"
      />
    </div>
  );
};

export default DataTableDetailDental;
